<template>
    <a-card title="队列监控">
      <a-space> 队列压力监控 <a-button type="primary" @click="handleTableChange">{{15 - refresh_couning  }}  秒后自动刷新</a-button> </a-space>      
      <table>
        
        <tr>
          <th style="width:200px;">executor</th><th style="width:40px;" >total</th>
          <th style="width:40px;" >using</th>
          <!-- <th style="width:40px;" >waiting</th> -->
          <th style="width:200px;" >pressure</th>
        </tr>
        <tr  v-for="(status, executor) in queue_topic_executing" :key="executor" >
          <td>
            <a :href="'/xae/queue/executors?topic=' + executor" >
              {{executor}}
            </a>
          </td> 
          <td>{{ status.total }}</td>  
          <td>{{ status.using }}</td>  
          <!-- <td>{{ status.waiting }}</td>   -->
          <td>
            <a-tag color="red"  v-if="status.pressture > 90" >
              {{ (status.pressture) }}%
            </a-tag>
            <a-tag color="orange"  v-else-if="status.pressture > 60" >
              {{ (status.pressture) }}%
            </a-tag>
            <a-tag color="green" v-else-if="status.pressture > 30" >
              {{ (status.pressture) }}%
            </a-tag>
            <a-tag color="blue" v-else >
              {{ (status.pressture) }}%
            </a-tag>
            <a-progress  :percent="status.pressture" :show-info="false" />
          </td>  
        </tr>
      </table>
      <hr />
      <h3>队列执行监控</h3>

      <table>
        <tr>
          <th style="width:200px;" >executor</th><th style="width:100px;" >status</th>
        </tr>
        <tr v-for="(cnt, idx) in queue_status['executing']" :key="idx" >
          <td>{{ idx }}</td>  
          <td>
            <a-tag v-if="cnt==1" color="green">执行中 ({{ cnt }})</a-tag> 
            <a-tag v-else color="red">并发 ({{ cnt }})</a-tag> 
          </td> 
        </tr>
      </table>
       
     
        <!-- <div v-for="(item, idx) in queue_status['queue_topic_executing']" :key="idx" >
          {{ item }} {{ idx }}
        </div> -->
      
    </a-card>

</template>
<script>
import { defineComponent,  } from 'vue'
// import UserEditor from '@/components/UserEditor.vue'
import request from '@/utils/request'
import { useStore } from 'vuex'

let refreshInterval = null

export default defineComponent({
  components: {
    // UserEditor,
  },
  data(){
    return {
      loading: false,
      openDia: false,
      dataSource: [],
      queue_status: {
        "executing": {
        },
        "executors": {
        },
      },
      is_auto_refresh: true,
      refresh_couning: 0,
      uploadLoading: false,
    }
  },
  unmounted(){
    refreshInterval && clearTimeout(refreshInterval)
  },
  mounted(){
    this.handleTableChange()
    if (this.is_auto_refresh) {
      this.loop()
    }
  },
  computed:{
    queue_topic_executing: function ()  {
      let topics = {}
      let executors =this.queue_status['executors']
      for (let topic in executors) {
        topics[topic] = {
          total: 0,
          using: 0,
          waiting: 0,
        }
        for(let executor in executors[topic]) {
          topics[topic].using += executors[topic][executor].using
          topics[topic].waiting += executors[topic][executor].waiting
          topics[topic].total += 1
        }
      }
      for (let k in topics) {
        topics[k].pressture = (topics[k].using / topics[k].total * 100).toFixed(2)
      }
      return topics
    },
    nickname : () => {
      const store = useStore()
      if (store) {
        return store.state.user.nickname
      }
      
    },
  },
  methods: {
    async loop(){
      refreshInterval = setTimeout(() => {
        this.refresh_couning ++
        if (this.refresh_couning >= 15) {
          refreshInterval && clearTimeout(refreshInterval)
          this.handleTableChange()
          this.refresh_couning = 0
        }  
        this.loop()
       
      }, 1000)
    },
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      this.loading = true
      const rsp = await request.get('/api/queues/executing_status', {})
      this.loading = false
      this.queue_status = rsp.data
    },
  },
  setup(props, context) {
    return {
      uploadInput: null,
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
</style>